import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FiOnboardingElementDropListHelperService {
    private stepElementDropListPrefix = 'steps-elements-drop-list-';

    public elementsDropListIds = new BehaviorSubject<string[]>([]);
    public getStepElementDropListIds$(): Observable<string[]> {
        return this.elementsDropListIds.asObservable();
    }
    public addStepElementDropListId(sectionIndex: number, stepIndex: number): void {
        this.elementsDropListIds.next([
            ...this.elementsDropListIds.value,
            `${this.stepElementDropListPrefix}${sectionIndex}-${stepIndex}`,
        ]);
    }
    public removeStepElementDropListId(sectionIndex: number, stepIndex: number): void {
        this.elementsDropListIds.next(
            this.elementsDropListIds.value.filter(
                (id) => id !== `${this.stepElementDropListPrefix}${sectionIndex}-${stepIndex}`,
            ),
        );
    }
    public getStepElementDropListIdByIndex(sectionIndex: number, stepIndex: number): string {
        return `${this.stepElementDropListPrefix}${sectionIndex}-${stepIndex}`;
    }
}
